import React from 'react';

import { flagStyles } from '../settings';

const SvgRussia = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5520px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgRussia;
